import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div
      *ngIf="loadingService.loading()"
      class="fixed inset-0 flex items-center justify-center bg-black/40" style="z-index: 9999;"
    >
      <p-progressSpinner></p-progressSpinner>
    </div>
  `,
})
export class AppLoadingOverlayComponent {
  constructor(public loadingService: LoadingService) {}
}
